import { styled } from '../../../lib/stitches'

const Spacer = styled('div', {
  height: 0,
  width: 0,
  variants: {
    type: {
      vertical_1: {
        marginTop: '$4',
        marginBottom: '$4'
      },
      vertical_2: {
        marginTop: '$8',
        marginBottom: '$8'
      },
      vertical_3: {
        marginTop: '$8',
        marginBottom: '$8'
      },
      vertical_4: {
        marginTop: '$10',
        marginBottom: '$10'
      },
      vertical_5: {
        marginTop: '$16',
        marginBottom: '$16'
      },
      vertical_6: {
        marginTop: '$24',
        marginBottom: '$24'
      },
      vertical_7: {
        marginTop: '$32',
        marginBottom: '$32'
      },
      horizontal_1: {
        marginLeft: '$4',
        marginRight: '$4'
      },
      horizontal_2: {
        marginLeft: '$8',
        marginRight: '$8'
      },
      horizontal_3: {
        marginLeft: '$8',
        marginRight: '$8'
      },
      horizontal_4: {
        marginLeft: '$10',
        marginRight: '$10'
      },
      horizontal_5: {
        marginLeft: '$16',
        marginRight: '$16'
      },
      horizontal_6: {
        marginLeft: '$24',
        marginRight: '$24'
      },
      horizontal_7: {
        marginLeft: '$32',
        marginRight: '$32'
      }
    }
  },
  defaultVariants: {
    type: 'vertical_1'
  }
})

export default Spacer
